import { render, staticRenderFns } from "./ProductTagsManage.vue?vue&type=template&id=56716b0e&scoped=true"
import script from "./ProductTagsManage.vue?vue&type=script&lang=js"
export * from "./ProductTagsManage.vue?vue&type=script&lang=js"
import style0 from "./ProductTagsManage.vue?vue&type=style&index=0&id=56716b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56716b0e",
  null
  
)

export default component.exports